/**
 * The todo form's time field (spec 2026-10-06 §7.7): PickerField showing "7:00 PM", with the
 * platform time picker on the form's day. A floating 'HH:MM' goes in and comes out — the Date only
 * exists for the picker.
 */
import React from 'react';
import { formatTime, timeOnDate, toTimeKey } from '@/utils/residents/todoTime';
import { PickerField } from './PickerField';

interface TimeFieldProps {
  /** 'HH:MM'. */
  value: string;
  /** The form's day, 'YYYY-MM-DD': the picker's Date sits on it. */
  dateKey: string;
  /** Native: whether the picker is up. Web keeps it mounted regardless. */
  open: boolean;
  onToggle: () => void;
  onClose: () => void;
  onChange: (timeKey: string) => void;
}

export const TimeField: React.FC<TimeFieldProps> = ({
  value,
  dateKey,
  open,
  onToggle,
  onClose,
  onChange,
}) => {
  const shown = formatTime(value);
  return (
    <PickerField
      label="Time"
      shown={shown}
      pickerName="time"
      mode="time"
      pickerValue={timeOnDate(dateKey, value)}
      open={open}
      onToggle={onToggle}
      onClose={onClose}
      onPick={picked => onChange(toTimeKey(picked))}
    />
  );
};

TimeField.displayName = 'TimeField';
